<script>
	import {Router, Route} from "svelte-routing";
	import {store} from './stores.js';
	
	import Auth from "./routes/Auth.svelte";
	import Dashboard from './routes/Dashboard.svelte';
	import Create from './routes/Create.svelte';
	import Order from './routes/Order.svelte';
	import Profile from './routes/Profile.svelte';
	import Chat from './routes/Chat.svelte';
	import Loading from "./routes/Loading.svelte";
	import AccessDenied from "./routes/AccessDenied.svelte";
	import InstallBanner from './components/InstallBanner.svelte';
	
	const user = store('credential', 'getAuth');
	
	export let url = "";
</script>

<svelte:window on:click={() => { window.top.postMessage('focus', '*'); }} />

<!-- App Capsule -->
<Router url="{url}">
	<Route path="/" component={Auth} />
	
	{#if $user.id > 0}
		<Route path="/dashboard" component={Dashboard} />
		<Route path="/create" component={Create} />
		<Route path="/order/:id" let:params>
			<Order id="{params.id}" />
		</Route>
		<Route path="/chat/:id" let:params>
			<Chat id="{params.id}" />
		</Route>
		<Route path="/profile" component={Profile} />
	{/if}
	
	<Route path="/loading" component={Loading} />
	<Route path="/*" component={AccessDenied} />

	<!-- Yandex.Metrika counter -->
	<script type="text/javascript" >
		(function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
			m[i].l=1*new Date();
			for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
			k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.defer=1,k.src=r,a.parentNode.insertBefore(k,a)})
		(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

		ym(92625765, "init", {
			clickmap:true,
			trackLinks:true,
			accurateTrackBounce:true,
			webvisor:true
		});
	</script>
	<noscript><div><img src="https://mc.yandex.ru/watch/92625765" style="position:absolute; left:-9999px;" alt="" /></div></noscript>
	<!-- /Yandex.Metrika counter -->
</Router>
<!-- * App Capsule -->

<InstallBanner />
